import React from "react";
import { Building2, Receipt } from "lucide-react";

export const BUSINESS_STATUS_LABELS = {
  none: "Не указан",
  self_employed: "Самозанятый",
  ip: "ИП",
  ooo: "ООО",
};

export const B2B_CONFIRM_TOAST = "Задание подтверждено. Пакет закрывающих документов сформирован и отправлен сторонам.";

export const hasBusinessStatus = (user) => !!user && !!user.business_status && user.business_status !== "none";

export const B2BTaskBadge = ({ compact = false, testId = "b2b-task-badge" }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium"
    style={{ background: "#F0F9FF", color: "#0C4A6E", border: "1px solid #7DD3FC" }}
    title="Задание от организации: оплата напрямую исполнителю, с закрывающими документами"
  >
    <Building2 size={12} />
    {compact ? "От организации" : "Оплата от организации напрямую исполнителю, с документами"}
  </span>
);

export const BusinessStatusBadge = ({ status, size = "xs", testId = "business-status-badge" }) => {
  if (!status || status === "none") return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-medium ${size === "sm" ? "text-sm" : "text-xs"}`}
      style={{ background: "#ECFDF5", color: "#065F46", border: "1px solid #6EE7B7" }}
      title="Исполнитель указал бизнес-статус и обязан выдать чек заказчику"
    >
      <Receipt size={12} />
      {BUSINESS_STATUS_LABELS[status] || status} — выдаёт чек
    </span>
  );
};
